function k() {
  return (k = Object.assign || function(b) {
    var a, d, c;
    for (a = 1; a < arguments.length; a++) {
      d = arguments[a];
      for (c in d) {
        Object.prototype.hasOwnProperty.call(d, c) && (b[c] = d[c]);
      }
    }
    return b;
  }).apply(this, arguments);
}

function q(b) {
  var a = m.digest({
    name: "SHA-256"
  }, b);
  return new Promise((function(b, c) {
    n ? (a.oncomplete = function d(a) {
      b(new Uint8Array(a.target.result));
    }, a.onerror = function h(b) {
      c(b);
    }) : Promise.resolve(a).then((function g(a) {
      b(new Uint8Array(a));
    })).catch((function y(b) {
      c(b);
    }));
  }));
}

function t(b) {
  var a, d, c, e;
  for (a = "", d = 0, c = b.length; d < c; d++) {
    e = b[d].toString(16);
    a += "00".slice(0, Math.max(0, 2 - e.length)) + e;
  }
  return a;
}

function v(b) {
  var a, d, c;
  try {
    if ("undefined" == typeof window ? !r || !r.createHash : !m) {
      return "production" !== process.env.NODE_ENV && console.warn("[@urql/exchange-persisted-fetch]: The " + ("undefined" == typeof window ? "Node Crypto" : "window.crypto.subtle") + " API is not available.\nThis is an unexpected error. Please report it by filing a GitHub Issue."), 
      Promise.resolve("");
    }
    if ("undefined" == typeof window) {
      return Promise.resolve("" + r.createHash("sha256").update(b).digest("hex"));
    }
    if ("undefined" != typeof TextEncoder) {
      a = (new TextEncoder).encode(b);
    } else {
      a = new Uint8Array(b.length);
      for (d = 0, c = b.length; d < c; d++) {
        a[d] = b.charCodeAt(d);
      }
    }
    return Promise.resolve(q(a)).then(t);
  } catch (e) {
    return Promise.reject(e);
  }
}

function w(b) {
  return "query" === b.operationName;
}

function z(b) {
  return "query" !== b.operationName;
}

function A(b, a, d, c) {
  c = k({}, b, {
    context: k({}, b.context, {
      preferGetMethod: c || b.context.preferGetMethod
    })
  });
  var e = makeFetchURL(c, a.query ? a : k({}, a, {
    query: ""
  })), h = makeFetchOptions(c, a);
  "production" !== process.env.NODE_ENV && d({
    type: "fetchRequest",
    message: a.query ? "A fetch request is being executed." : "A fetch request for a persisted query is being executed.",
    operation: c,
    data: {
      url: e,
      fetchOptions: h
    },
    source: "persistedFetchExchange"
  });
  return onPush((function(a) {
    var c = a.error && (a.error.graphQLErrors.some(B) || a.error.graphQLErrors.some(C)), g = a.data ? void 0 : a.error;
    "production" !== process.env.NODE_ENV && d({
      type: c || g ? "fetchError" : "fetchSuccess",
      message: c ? "A Persisted Query request has failed. A non-persisted GraphQL request will follow." : "A " + (g ? "failed" : "successful") + " fetch response has been returned.",
      operation: b,
      data: {
        url: e,
        fetchOptions: h,
        value: c ? a.error : g || a
      },
      source: "persistedFetchExchange"
    });
  }))(makeFetchSource(c, e, h));
}

function B(b) {
  return "PersistedQueryNotFound" === b.message;
}

function C(b) {
  return "PersistedQueryNotSupported" === b.message;
}

var l, m, n, r;

import { makeFetchBody, makeFetchSource, makeFetchURL, makeFetchOptions } from "@urql/core/internal";

import { share, mergeMap, filter, takeUntil, onPush, fromValue, fromPromise, merge } from "wonka";

l = "undefined" != typeof window ? window.crypto || window.msCrypto : void 0, m = l && (l.subtle || l.webkitSubtle), 
n = !(!l || !window.msCrypto);

r = "undefined" == typeof window ? eval("require('crypto')") : null;

export function persistedFetchExchange(b) {
  return function(a) {
    var e, h, d = a.forward, c = a.dispatchDebug;
    b || (b = {});
    e = b.generateHash || v, h = !0;
    return function(a) {
      var x, g = share(a);
      a = mergeMap((function(a) {
        var p, d = a.key, u = filter((function(a) {
          return "teardown" === a.operationName && a.key === d;
        }))(g), f = makeFetchBody(a);
        if (!h) {
          return takeUntil(u)(A(a, f, c, !1));
        }
        p = f.query;
        return takeUntil(u)(mergeMap((function(b) {
          return b.error && b.error.graphQLErrors.some(C) ? (f.query = p, f.extensions = void 0, 
          h = !1, A(a, f, c, !1)) : b.error && b.error.graphQLErrors.some(B) ? (f.query = p, 
          A(a, f, c, !1)) : fromValue(b);
        }))(mergeMap((function(d) {
          d && (f.query = void 0, f.extensions = {
            persistedQuery: {
              version: 1,
              sha256Hash: d
            }
          });
          return A(a, f, c, !(!b.preferGetForPersistedQueries || !d));
        }))(fromPromise(e(p, a.query)))));
      }))(filter(w)(g));
      x = d(filter(z)(g));
      return merge([ a, x ]);
    };
  };
}
//# sourceMappingURL=urql-exchange-persisted-fetch.mjs.map
